module.exports = __webpack_public_path__ + "img/recharge-empty.148b147e.png";